export default  [
	{
		id: 1,
		title: 'The Art Of War',
		price: 10.11,
		image:
			'https://images-na.ssl-images-amazon.com/images/I/41FBMkY3cgL._SX331_BO1,204,203,200_.jpg'
	},
	{
		id: 2,
		title: 'Civilization and Its Discontents',
		price: 14.29,
		image:
			'https://images-na.ssl-images-amazon.com/images/I/51Jj12iMZnL._SX331_BO1,204,203,200_.jpg'
	},
	{
		id: 3,
		title: 'Influence: The Psychology of Persuasion',
		price: 10.98,
		image:
			'https://images-na.ssl-images-amazon.com/images/I/512-B-1yXuL._SX331_BO1,204,203,200_.jpg'
	},
	{
		id: 4,
		title: 'Grokking Algorithms',
		price: 40.00,
		image:
			'https://images-na.ssl-images-amazon.com/images/I/61uUPXbhMxL._SX397_BO1,204,203,200_.jpg'
	},
	{
	   id: 4605696278643,
	   title: "L'Art Brut Magazine, nos. 1-8 ed. by Jean Dubuffet & le Compagnie de l'Art Brut (French)",
	   price: 650,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/10.ArtBrut_2.jpg?v=1603824795"
	},
	{
	   id: 4605286711411,
	   title: "Color by Quant: Your Complete Personal Gid to Beauty and Fashion",
	   price: 30,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/7.Quant_Cover_fe59a05f-4cc4-42f8-9512-6b13f8b23099.jpg?v=1603897799"
	},
	{
	   id: 4605284548723,
	   title: "James Joyce's Tower by Richard Ellmann",
	   price: 40,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/12.Joyce_Cover.jpg?v=1603826117"
	},
	{
	   id: 4605282156659,
	   title: "Minima Moralia: Reflections from Damaged Life by Theodor Adorno",
	   price: 125,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/3.Adorno_Cover.jpg?v=1603807223"
	},
	{
	   id: 4605278814323,
	   title: "Translations by American Poets (ed. Jean Garrigue)",
	   price: 30,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/12.Translations_Cover.jpg?v=1603899434"
	},
	{
	   id: 4605277110387,
	   title: "Erich Mendelsohn: Complete Works by the Architect (Sketches, Designs, Buildings)",
	   price: 40,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/2.Mendelsohn_Cover.jpg?v=1603807142"
	},
	{
	   id: 4605271900275,
	   title: "Image Being by Bill Bissitt",
	   price: 25,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/8.Concrete_Cover.jpg?v=1603900672"
	},
	{
	   id: 4605268197491,
	   title: "Ed Ruscha: Leave Any Information at the Signal",
	   price: 75,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/6.Ruscha_Cover.jpg?v=1603808398"
	},
	{
	   id: 4605264756851,
	   title: "Moholy-Nagy: Photographs & Photograms by Andreas Haus",
	   price: 60,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/4.Nagy_Cover.jpg?v=1603808211"
	},
	{
	   id: 4605219111027,
	   title: "Yves Klein: Selected Writings, 1928–1962",
	   price: 120,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/9.Klein_Cover.jpg?v=1603824611"
	},
	{
	   id: 4605198631027,
	   title: "Brett Weston: Photographs",
	   price: 30,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/5.Weston_Cover.jpg?v=1603808309"
	},
	{
	   id: 4605187948659,
	   title: "Dead Battery by Andy Spade",
	   price: 15,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/1.DeadBattery_Cover.jpg?v=1603807078"
	},
	{
	   id: 4603184873587,
	   title: "Looking Good: A Gid for Men by Charles Hix (w. Photos by Bruce Weber)",
	   price: 70,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/10.LookingGood_Covercopy_bec70ccf-ec82-4552-a3bd-a9f1d032b097.jpg?v=1603234042"
	},
	{
	   id: 4603173109875,
	   title: "The Work of Jean Dubuffet by Peter Seltz & with texts by the artist",
	   price: 60,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/7.Dubuffet.jpg?v=1603161279"
	},
	{
	   id: 4603170521203,
	   title: "China Diary by Stephen Spender & DaidHockney",
	   price: 50,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/8.ChinaDiary.jpg?v=1603213875"
	},
	{
	   id: 4603168817267,
	   title: "The Figure of Beatrice: a study in Dante by Charles Williams",
	   price: 40,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/2.Beatrice_Cover.jpg?v=1603154968"
	},
	{
	   id: 4603168653427,
	   title: "Barnett Newman by Thomas B. Hess",
	   price: 125,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/6.Newman.jpg?v=1603160682"
	},
	{
	   id: 4603154825331,
	   title: "Colette: Mitsou and Music-Hall idlights",
	   price: 30,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/2.Colette_Cover.jpg?v=1603154327"
	},
	{
	   id: 4602828259443,
	   title: "Violin-Making: as it was, and is by Ed. Heron-Allon",
	   price: 30,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/4.Violin_Cover.jpg?v=1603159624"
	},
	{
	   id: 4602823901299,
	   title: "Cahier de Georges Braque, 1917–1977",
	   price: 100,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/9.Braque_Cover_9aeeb67a-25b6-4ba6-8d51-a76cd8f06faf.jpg?v=1603234416"
	},
	{
	   id: 4602812727411,
	   title: "Who Knows: Poems and Aphorisms by Francis Picabia",
	   price: 95,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/1.Picabia_Cover_WEB.jpg?v=1603152670"
	},
	{
	   id: 4602782580851,
	   title: "The Next Whole Earth Catalog: access to tools (1980)",
	   price: 125,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/10.WholeEarth_Covercopy_85d470fa-8030-482e-80fa-91f5175d186b.jpg?v=1603234132"
	},
	{
	   id: 4600167628915,
	   title: "'Whole Earth Epilog' Magazine (1974)",
	   price: 75,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/10.WholeEarthEpilog_full.jpg?v=1602524584"
	},
	{
	   id: 4600166154355,
	   title: "Bloomsbury Reflections by Alen MacWeeney and Sue Allison",
	   price: 55,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/9.BloomsburyReflections.jpg?v=1602508617"
	},
	{
	   id: 4600165531763,
	   title: "Conversations with Architects by John W. Cook & Heinrich Klotz",
	   price: 40,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/8.Convos_Cover.jpg?v=1602508379"
	},
	{
	   id: 4600163729523,
	   title: "Being Geniuses Together, 1920–1930 by Robert McAlmon with Kay Boyle",
	   price: 40,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/4.BeingGeniuses_Covercopy.jpg?v=1602509328"
	},
	{
	   id: 4599095296115,
	   title: "Rene Ricard: Notebook, 2010–2012",
	   price: 375,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/6.Ricard_Cover.jpg?v=1602523900"
	},
	{
	   id: 4595629916275,
	   title: "An Adventure of the Thought Police by Peter Schjeldahl",
	   price: 60,
	   image: "https://cdn.shopify.com/s/files/1/0880/2454/products/Schjeldahl_Cover.jpg?v=1601752350"
	},
	{
		id: 4595621396595,
		title: "Denton Welch: A Selection from his Published Works",
		price: 22,
		image: "https://cdn.shopify.com/s/files/1/0880/2454/products/Welch_Cover.jpg?v=1601753431"
	}
  ];
